<template>
	<div class="page-top">
		<div class="ass-head" ref="assHead">
			<i class="iconfont icon-back" @click="back" :title="backTitle"></i>
			<ul class="topic-num">
				<li v-for="(s, i) in subjectList" :key="s.id"
					:class="[currentTopic==i&&'active',isLookingBack?(s.correct?'correct':'wrong'):(s.choice.length!=0&&'select')]"
					@click="changeSubject(i)">
					{{ i+1 }}
				</li>
			</ul>
		</div>
		<slot />
	</div>
</template>

<script>
	export default {
		name: "pageTop",
		components: {},
		props: {
			backTitle: { // 鼠标悬停返回按钮上的提示文字
				type: String,
				default: "返回"
			}
		},
		data() {
			return {
				subjectList: [], // 题目列表
				currentTopic: 0, // 当前
				isLookingBack: false, // 是否是回看
			}
		},
		created() {},
		mounted() {},
		methods: {
			back() { // 返回
				this.$router.go(-1);
			},
			setSubjectList(list) {
				this.subjectList = list;
			},
			changeSubject(num) { // 切换题目
				this.currentTopic = num;
				this.$emit("setCurrentTopic", num);
			},
			setLookingBack(type) {
				this.isLookingBack = type
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page-top {
		height: 100%;
		width: 100%;
		background: url(~@/assets/img/mainBg.png) no-repeat;
		background-size: 100% 100%;
		color: #FFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 0;

		.ass-head {
			height: 3.8rem;
			line-height: 3.8rem;
			background-color: #252629;
			border-bottom: 0.4rem solid #203B4D;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 1.6rem;

			.icon-back {
				font-size: 1.68rem;
				cursor: pointer;
				color: #FFF;
				margin-left: 0.4rem;
				margin-right: 3.6rem;
			}

			.topic-num {
				display: flex;
				overflow: auto;
				height: 100%;
				align-items: center;

				li {
					display: inline-table;
					width: 1.6rem;
					height: 1.6rem;
					text-align: center;
					line-height: 1.6rem;
					color: #FFF;
					font-size: 0.72rem;
					background-color: #748C9A;
					border-radius: 50%;
					margin-left: 0.6rem;
					// margin-bottom: 0.3rem;
					cursor: pointer;
					user-select: none;
				}

				li.wrong {
					background-color: #F56C6C;
				}

				li.correct {
					background-color: #67c23a;
				}

				li.select {
					background-color: #35EAFF;
				}

				li.active {
					background-color: #409EFF;
				}
			}
		}
	}
</style>